/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_No_ResultsInputs */

const en_ui_no_results = /** @type {(inputs: Ui_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No results`)
};

/** @type {(inputs: Ui_No_ResultsInputs) => LocalizedString} */
const ar_ui_no_results = en_ui_no_results;

/** @type {(inputs: Ui_No_ResultsInputs) => LocalizedString} */
const he_ui_no_results = en_ui_no_results;

/** @type {(inputs: Ui_No_ResultsInputs) => LocalizedString} */
const ur_ui_no_results = en_ui_no_results;

/** @type {(inputs: Ui_No_ResultsInputs) => LocalizedString} */
const es_ui_no_results = en_ui_no_results;

/** @type {(inputs: Ui_No_ResultsInputs) => LocalizedString} */
const fr_ui_no_results = en_ui_no_results;

/** @type {(inputs: Ui_No_ResultsInputs) => LocalizedString} */
const de_ui_no_results = en_ui_no_results;

/** @type {(inputs: Ui_No_ResultsInputs) => LocalizedString} */
const pt_ui_no_results = en_ui_no_results;

/** @type {(inputs: Ui_No_ResultsInputs) => LocalizedString} */
const hi_ui_no_results = en_ui_no_results;

/** @type {(inputs: Ui_No_ResultsInputs) => LocalizedString} */
const bn_ui_no_results = en_ui_no_results;

/**
* | output |
* | --- |
* | "No results" |
*
* @param {Ui_No_ResultsInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const ui_no_results = /** @type {((inputs?: Ui_No_ResultsInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_No_ResultsInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_ui_no_results(inputs)
	if (locale === "he") return he_ui_no_results(inputs)
	if (locale === "ur") return ur_ui_no_results(inputs)
	if (locale === "es") return es_ui_no_results(inputs)
	if (locale === "fr") return fr_ui_no_results(inputs)
	if (locale === "de") return de_ui_no_results(inputs)
	if (locale === "pt") return pt_ui_no_results(inputs)
	if (locale === "hi") return hi_ui_no_results(inputs)
	if (locale === "bn") return bn_ui_no_results(inputs)
	return /** @type {LocalizedString} */ ("No results")
});